document.getElementById("v2-generate").onclick = async function(){

  const btn = this

  const prompt = document.getElementById("v2-prompt").value
  const niche = document.getElementById("v2-niche").value

  if(!prompt){
    alert("Enter prompt")
    return
  }

  /* 🔥 LOADING STATE */
  btn.classList.add("loading")
  btn.innerHTML = 'Generating <span class="v2-dots"><span></span><span></span><span></span></span>'

  try {

    const res = await fetch("https://back-apis.printpromp.com/ai-generate.php",{
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({prompt,niche})
    })

    const data = await res.json()

    const container = document.getElementById("v2-results")
    document.getElementById("v2-instruction").classList.remove("hidden")
    container.innerHTML=""

    data.images.forEach(url=>{

      const img = document.createElement("img")
      img.src = url

      img.onclick = function(){

        document.getElementById("v2-customizer").style.display = "block"

        const design = document.getElementById("v2-design")
        design.src = url

        design.style.left = "50%"
        design.style.top = "42%"
        design.style.transform = "translate(-50%, -50%) scale(1)"
      }

      container.appendChild(img)
    })

  } catch(e){
    alert("Something went wrong")
  }

  /* 🔥 RESET BUTTON */
  btn.classList.remove("loading")
  btn.innerHTML = "➜ Generate"
}